
import React, {useEffect, useState} from "react";
import {connect} from 'react-redux';
import moment from 'moment';
import {Select, Form} from "antd";
import { browserHistory } from 'react-router';

import CustomButton from "../../common/CustomButton.js";
import {
    getVendorTraceUrlsData,
    getVendorTraceRegionsData,
    getVendorTracePropertiesData
} from "../../../api/diagnose_dashboard/vendor_trace";
import useSearchParams from '../../diagnose_dashboard/shared/useSearchParams';

const periodList = [
    "Yesterday",
    "Last 7 days",
];

const today = moment().format("YYYY-MM-DD");
const yesterday = moment().subtract(1, 'days').format("YYYY-MM-DD");
const last7days = moment().subtract(7, 'days').format("YYYY-MM-DD");

const VendorTraceFilters = ({ onApply }) => {
    const searchParams = useSearchParams();

    const [property, setProperty] = useState(null);
    const [scannedPeriod, setScannedPeriod] = useState(null);

    const [propertiesList, setProperties] = useState([]);
    const [propertiesListLoading, setPropertiesLoading] = useState(false);

    const [scannedUrl, setScannedUrl] = useState(null);
    const [scheduledScanIds, setScheduledScanIds] = useState([]);
    const [scanIds, setScanIds] = useState([]);
    const [urlList, setUrlList] = useState([]);
    const [urlListLoading, setUrlListLoading] = useState(false);

    const [region, setRegion] = useState(null);
    const [regionsList, setRegionList] = useState([]);
    const [regionsListLoading, setRegionListLoading] = useState(false);

    const Option = Select.Option;
    useEffect(() => {
        if (Object.keys(searchParams).length && searchParams?.start_date && searchParams?.end_date && searchParams?.scheduled_scan_ids && searchParams?.property && searchParams?.region) {
            const loadFilters = async () => {
                const scheduledScanIdsFromSearchParams = searchParams.scheduled_scan_ids.split(',');
                const applyFilters = async () => {
                    let filters = {
                        property: searchParams.property,
                        scannedPeriod: {
                            dateFrom: searchParams.start_date,
                            dateTo: searchParams.end_date,
                        },
                        scannedUrl: scheduledScanIdsFromSearchParams,
                        region: searchParams.region,
                    };
                    onApply(filters);
                }
                const propetyList = async () => {
                    /* Properties List */
                    setScannedPeriod('Last 7 days');
                    setPropertiesLoading(true);
                    const propertiesData = await getVendorTracePropertiesData({
                        dateFrom: searchParams.start_date,
                        dateTo: searchParams.end_date,
                    });
                    setProperties(propertiesData);
                    setProperty(searchParams.property);
                    setPropertiesLoading(false);
                }
                const urlList = async () => {
                    /* Url List */
                    setUrlListLoading(true);
                    const urlsData = await getVendorTraceUrlsData({
                        dateFrom: searchParams.start_date,
                        dateTo: searchParams.end_date,
                        websiteId: searchParams.property
                    })
                    setUrlList(urlsData);
                    setScannedUrl(searchParams.url);
                    setScheduledScanIds(scheduledScanIdsFromSearchParams);
                    setUrlListLoading(false);
                }
                const regionsList = async () => {
                    /* Regions List */
                    setRegionListLoading(true)
                    const regionsData = await getVendorTraceRegionsData({
                        dateFrom: searchParams.start_date,
                        dateTo: searchParams.end_date,
                        scheduledScanId: scheduledScanIdsFromSearchParams,
                        scanId: undefined,
                    })
                    setRegionList(regionsData);
                    setRegion(searchParams.region);
                    setRegionListLoading(false);
                }
                await Promise.all([propetyList(), urlList(), regionsList(), applyFilters()]);
            }
            loadFilters();
        }
    }, []);

    const handleSelectProperty = (value) => {
        setScannedUrl(null);
        setRegion(null);
        setProperty(value);
        setUrlListLoading(true);
        if(value) {
            getVendorTraceUrlsData({
                dateFrom: (scannedPeriod === 'Yesterday' ? yesterday : last7days),
                dateTo: (scannedPeriod === 'Yesterday' ? yesterday : today),
                websiteId: value
            }).then((resp) => {
                setUrlList(resp);
            }).then(e=>setUrlListLoading(false));
        }
    };
    const handleClearProperty = () => {
        setScannedUrl(null);
    };

    const handleSelectPeriod = (value) => {
        setProperty(null);
        setScannedUrl(null);
        setRegion(null);
        setScannedPeriod(value);
        setPropertiesLoading(true);
        if(value) {
            getVendorTracePropertiesData({
                dateFrom: (value === 'Yesterday' ? yesterday : last7days),
                dateTo: (value === 'Yesterday' ? yesterday : today),
            }).then((resp) => {
                setProperties(resp);
            }).then(e => {
                setPropertiesLoading(false)
            });
        }
    };
    const handleClearPeriod = () => {
        setProperty(null);
        setScannedUrl(null);
        setRegion(null);
    };

    const handleSelectUrl = (value) => {
        setRegion(null);
        setScannedUrl(value);
        const parsed = JSON.parse(value);
        setScheduledScanIds(value ? parsed.scheduled_scan_ids : []);
        setScanIds(value ? parsed.scan_ids : []);
        if(value) {
            setRegionListLoading(true)
            getVendorTraceRegionsData({
                dateFrom: (scannedPeriod === 'Yesterday' ? yesterday : last7days),
                dateTo: (scannedPeriod === 'Yesterday' ? yesterday : today),
                scheduledScanId: parsed.scheduled_scan_ids,
                scanId: parsed.scan_ids,
            }).then((resp) => {
                setRegionList(resp);
            }).then(e=>setRegionListLoading(false));
        }
    };

    const handleClearUrl = () => {
        setRegion(null);
    };

    const handleSelectRegion = (value) => {
        setRegion(value);
    };

    const handleApply = () => {
        let filters = {
            property,
            scannedPeriod: {
                dateFrom: (scannedPeriod === 'Yesterday' ? yesterday : last7days),
                dateTo: (scannedPeriod === 'Yesterday' ? yesterday : today),
            },
            scannedUrl: scheduledScanIds,
            region,
            scanIds
        };
        browserHistory.replace(location.pathname);
        onApply(filters);
    };

    const onFinish = (values) => {
        handleApply();
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    return (
        <div>
            <Form
                className={'vendor_trace_filter'}
                name="diagnose_filters"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
                // initialValues={{
                //   dates: range,
                // }}
                fields={[
                    {name: ['period'], value: scannedPeriod},
                    {name: ['property'], value: property},
                    {name: ['url'], value: scannedUrl},
                    {name: ['region'], value: region},
                ]}
                requiredMark={'optional'}
            >

                {/* period */}
                <Form.Item
                    label="Scanned Period:"
                    name="period"
                    rules={[
                        {
                            required: true,
                            message: 'This field is required',
                        },
                    ]}
                >
                    <Select
                        getPopupContainer={trigger => trigger.parentElement}
                        allowClear={true}
                        placeholder={"Period"}
                        value={scannedPeriod}
                        onChange={handleSelectPeriod}
                        onClear={handleClearPeriod}
                        size="medium"
                        showSearch
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            || option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {periodList?.map((period, index) => {
                            return (
                                <Option key={`period-${index}`} value={period}>
                                    {period}
                                </Option>
                            );
                        })}
                    </Select>
                </Form.Item>

                {/* property */}
                <Form.Item
                    label="Property:"
                    name="property"
                    rules={[
                        {
                            required: true,
                            message: 'This field is required',
                        },
                    ]}
                >
                    <Select
                        getPopupContainer={trigger => trigger.parentElement}
                        loading={propertiesListLoading}
                        allowClear={true}
                        placeholder={"Property"}
                        disabled={!scannedPeriod}
                        value={property}
                        onChange={handleSelectProperty}
                        onClear={handleClearProperty}
                        className={property === searchParams.property ? "diagnose-notification-highlight selector" : ""}
                        size="medium"
                        showSearch
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            || option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {propertiesList?.map((site, index) => {
                            return (
                                <Option key={`property-${site?.website_id}-${index}`} value={site?.website_id}>
                                    {site?.name}
                                </Option>
                            );
                        })}
                    </Select>
                </Form.Item>

                {/* urls */}
                <Form.Item
                    label="Scan URL:"
                    name="url"
                    rules={[
                        {
                            required: true,
                            message: 'This field is required',
                        },
                    ]}
                >
                    <Select
                        getPopupContainer={trigger => trigger.parentElement}
                        loading={urlListLoading}
                        disabled={!(scannedPeriod && property)}
                        allowClear={true}
                        placeholder={"Url"}
                        value={scannedUrl}
                        onChange={handleSelectUrl}
                        onClear={handleClearUrl}
                        className={scannedUrl === searchParams.url ? "diagnose-notification-highlight selector" : ""}
                        size="medium"
                        showSearch
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            || option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {urlList?.map((url, index) => {
                            return (
                                <Option key={url.url} value={JSON.stringify(url)}>
                                    {url.url}
                                </Option>
                            );
                        })}
                    </Select>
                </Form.Item>

                {/* region */}
                <Form.Item
                    label="Region Scanned:"
                    name="region"
                    rules={[
                        {
                            required: true,
                            message: 'This field is required',
                        },
                    ]}
                >
                    <Select
                        getPopupContainer={trigger => trigger.parentElement}
                        loading={regionsListLoading}
                        disabled={!(scannedUrl && scannedPeriod)}
                        allowClear={true}
                        placeholder={"Region"}
                        value={region}
                        className={region === searchParams.region ? "diagnose-notification-highlight selector" : ""}
                        onChange={handleSelectRegion}
                        size="medium"
                        showSearch
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            || option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {regionsList?.map((region, index) => (
                            <Option key={`region-item-${index}`} value={region.alpha_2}>
                                {region.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>


                <CustomButton className="create-button" htmlType="submit" disabled={!(property && scannedUrl && scannedPeriod && region)}>
                    APPLY
                </CustomButton>
            </Form>
        </div>
    );
};


const mapStateToProps = function (store) {
    return {
        currentUser: store.accountState.getIn(['userDetails', 'value']),
    };
};

export default connect(mapStateToProps, null)(VendorTraceFilters);
